/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdDomainModelsDBDBInviteInviteStatusErrorCode;
(function (FxIdDomainModelsDBDBInviteInviteStatusErrorCode) {
    FxIdDomainModelsDBDBInviteInviteStatusErrorCode[FxIdDomainModelsDBDBInviteInviteStatusErrorCode["Created"] = 0] = "Created";
    FxIdDomainModelsDBDBInviteInviteStatusErrorCode[FxIdDomainModelsDBDBInviteInviteStatusErrorCode["Success"] = 1] = "Success";
    FxIdDomainModelsDBDBInviteInviteStatusErrorCode[FxIdDomainModelsDBDBInviteInviteStatusErrorCode["FailedGameOfThisTypeAlreadyConnectedToYourAccount"] = 1000] = "FailedGameOfThisTypeAlreadyConnectedToYourAccount";
    FxIdDomainModelsDBDBInviteInviteStatusErrorCode[FxIdDomainModelsDBDBInviteInviteStatusErrorCode["FailedThisGameAccountAlreadyConnectedToAnotherAccount"] = 1001] = "FailedThisGameAccountAlreadyConnectedToAnotherAccount";
    FxIdDomainModelsDBDBInviteInviteStatusErrorCode[FxIdDomainModelsDBDBInviteInviteStatusErrorCode["FailedTimeout"] = 1002] = "FailedTimeout";
    FxIdDomainModelsDBDBInviteInviteStatusErrorCode[FxIdDomainModelsDBDBInviteInviteStatusErrorCode["FailedGameOfThisTypeNotConnectedToYourAccount"] = 1003] = "FailedGameOfThisTypeNotConnectedToYourAccount";
    FxIdDomainModelsDBDBInviteInviteStatusErrorCode[FxIdDomainModelsDBDBInviteInviteStatusErrorCode["FailedForUnknownReason"] = 1999] = "FailedForUnknownReason";
    FxIdDomainModelsDBDBInviteInviteStatusErrorCode[FxIdDomainModelsDBDBInviteInviteStatusErrorCode["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainModelsDBDBInviteInviteStatusErrorCode || (FxIdDomainModelsDBDBInviteInviteStatusErrorCode = {}));
export function instanceOfFxIdDomainModelsDBDBInviteInviteStatusErrorCode(value) {
    for (const key in FxIdDomainModelsDBDBInviteInviteStatusErrorCode) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainModelsDBDBInviteInviteStatusErrorCode, key)) {
            if (FxIdDomainModelsDBDBInviteInviteStatusErrorCode[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainModelsDBDBInviteInviteStatusErrorCodeFromJSON(json) {
    return FxIdDomainModelsDBDBInviteInviteStatusErrorCodeFromJSONTyped(json, false);
}
export function FxIdDomainModelsDBDBInviteInviteStatusErrorCodeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainModelsDBDBInviteInviteStatusErrorCodeToJSON(value) {
    return value;
}
export function FxIdDomainModelsDBDBInviteInviteStatusErrorCodeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainModelsDBDBInviteInviteStatusErrorCode.js.map